import { createContext, useState } from 'react';
import api from 'services/api';

const filter = {
  like: '',
  id: '',
  etapa: '',
  descricao: '',
  orientacao: '',
  responsavel: [],
  tempomin: '',
  tempomax: '',
  manual: null,
  permite_proposta: null,
  proposta: null,
  concluir_lead: null,
};

export const CrmFunilContext = createContext();

export const CrmFunilProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [crmFunil, setCrmFunil] = useState({
    data: [],
    colunas: [],
    filter,
    page: 0,
    size: 10,
  });

  const getCrmFunil = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: crmFunil?.filter,
        page: crmFunil?.page,
        size: crmFunil?.size,
        order: crmFunil?.order,
        ...payload,
      });
      setCrmFunil((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <CrmFunilContext.Provider
      value={{
        getLoading,
        crmFunil,
        getCrmFunil,
      }}
    >
      {children}
    </CrmFunilContext.Provider>
  );
};
